import AppHeader from '../AppHeader'

export default {
  name: 'master-consumable-item-shop-stock-count-list',
  created () {
    this.getConsumableItemCount()
  },
  data () {
    return {
      consumableItemCounts: [],
      consumable_item_name: ''
    }
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {
    async getConsumableItemCount () {
      const data = {
        consumable_item_id: this.$route.params.consumable_item_id
      }
      let res = await this.$store.dispatch('GET_CONSUMABLE_ITEM_SHOP_STOCK_COUNT', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      this.consumableItemCounts = res.shop_consumable_item_count
      this.consumable_item_name = res.consumable_item_name
    },
    goConsumableItemStockCountEdit (itemId, shopId) {
      this.$router.push({path: '/master_consumable_item/' + `${itemId}` + '/stock_count/' + `${shopId}` + '/edit'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-consumable-item-shop-stock-count-list.js